export default __webpack_public_path__ + "static/media/Carriersafetyservices.1011d8e4.png";